import React from 'react';
import { Link } from 'react-router-dom';
import storage from '../../assets/storage4.jpg';
import storage1 from '../../assets/storage1.jpg';

const Storage =()=>{

    return(
        <section className='container mx-auto px-4 md:px-0 font-nunito mt-16'>
             <div className="relative">
                <img src={storage} alt="Slide 3" className="w-full h-64 md:h-80 lg:h-96 object-cover" />
                <div className="absolute inset-0 flex items-center justify-center">
                    <h2 className="text-white text-4xl lg:text-6xl font-bold text-center">Storage Solutions </h2>
                </div>
            </div>
            <div className="flex flex-col md:flex-row items-center mt-8">
                <img src={storage1} alt="About Us" className="w-full md:w-1/2 md:mt-0 object-cover" /> <br />
                <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                    <h1 className='font-bold text-center text-justify lg:text-4xl'>Storage Solutions</h1>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                        Data storage involves using recording media to retain information on computers or other devices. It covers various aspects, such as the type, location, and methods used by hardware or software to store, delete, back up, organize, and secure data. As data grows exponentially, it is projected that by 2025, over 200 zettabytes of information will be produced annually. With this surge in data volume, securely and cost-effectively storing information has become crucial for businesses of all sizes.
                    </p>
                    <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                        A wide range of storage options is available to address these considerations, enabling businesses to select the most appropriate and effective solutions. By carefully evaluating these factors, organizations can ensure that they implement a data storage system that meets their specific needs, enhancing data security, accessibility, and cost-efficiency.
                    </p>
                </div>
            </div> 
            <br />
                <hr />
            <br />
            <div className='md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify'>
                <h1 className='font-bold text-center text-justify lg:text-4xl'> Benefits of Storage Solutions for Businesses</h1><br />
                <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                    Data and analytics can help a business predict consumer behavior, improve decision-making and market trends. As an organization grows, the need for enterprise data storage solutions also grows. It becomes even more challenging to ensure that your company’s data can be easily stored, accessed, and protected. Having a storage can easily support all your workloads without stretching your resources.
                </p>
            </div><br />
            <hr /><br />
            <div className="md:ml-8 flex-1 mt-4 md:mt-0 flex-1 mr-5 text-justify">
                <p className="mt-4 md:mt-0 text-lg md:text-xl text-justify">
                    Managing and storing information is crucial to a company's operational success. IBS offers expert assistance in designing, deploying, and supporting various storage solutions tailored to your business needs. Our services help you maximize return on investment (ROI) while maintaining a low total cost of ownership (TCO). With IBS, you can ensure your data is stored securely and efficiently, supporting your business's growth and success.
                </p>
            </div>
            <br /><br /><br />
            <div className="flex flex-col justify-center items-center space-y-4">
                <h1 className="font-bold text-center lg:text-4xl">
                Get the best storage solution by connecting with our experts!
                </h1>
                <div>
                    <button className="rounded bg-[#023B8D] py-2 px-4 font-bold text-[#C5B358] transition-transform duration-300 hover:scale-110 hover:bg-[#013751]">
                      <Link to={'/ContactPage'}> Talk to Us</Link> 
                    </button>
                </div>
            </div>
            </section>
           
        )
}
export default Storage;